<template>
  <b-form-group class="flat-picker" :label="label" :label-for="id">
    <validation-provider
      mode="passive"
      #default="{ errors }"
      :name="label"
      :rules="rules"
    >
      <flat-pickr
        class="form-control"
        :id="id"
        v-bind="$attrs"
        v-on="$listeners"
        :config="{
          ...config,
          locale: Arabic,
        }"
        :class="{ 'invalid-date': errors.length > 0 }"
      />
      <small v-if="errors && errors.length" class="text-danger">{{
        errors[0]
      }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { Arabic } from "./ar.js";
export default {
  components: { BFormGroup, flatPickr, ValidationProvider },
  props: {
    id: {
      type: String,
      default: () => "multi-datepicker",
    },
    name: {
      type: String,
      default: () => "multi-datepicker",
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    config: {
      type: Object,
      default: () => {
        return { mode: "range", locale: Arabic };
      },
    },
  },
  data() {
    return {
      Arabic,
    };
  },
};
</script>

<style lang="scss">
.flat-picker {
  .invalid-date + .form-control {
    border-color: var(--danger) !important;
  }
  .form-control {
    background-color: white;
  }
}

.ngo-datepicker {
  footer {
    display: none;
  }
  .dropdown-menu {
    width: fit-content !important;
  }
  .b-form-date-calendar {
    width: fit-content !important;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
